import {SUCCESS,
        ERROR,
        CLEAR} from '../constants/ActionTypes';

const initialState = {};

export default function alert(state = initialState, action) {
    switch (action.type) {
        case SUCCESS:
            return {
                type: 'alert-success',
                message: action.message
            };
        case ERROR:
            return {
                type: 'alert-danger',
                message: action.message
            };
        case CLEAR:
            return {};
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/reducers/alert.js